import { uploadData, getUrl } from 'aws-amplify/storage'
import { CustomFile } from '../components/common/DropFileInput/DropFileInput'
import { Platform } from 'react-native'

export const ReportProblemService = () => {
    const putStorageFile = async (
        fileName: string,
        selectedFile: CustomFile,
        progressCallback?: (progress: any) => void
    ) => {
        try {
            let blob
            console.log('selectedFile', selectedFile)
            // Handle different file sources
            if (selectedFile.uri.startsWith('data:')) {
                // Handle base64 data URI
                const base64Data = selectedFile.uri.split(',')[1]

                if (Platform.OS === 'web') {
                    // For web, we can use the fetch API
                    const response = await fetch(selectedFile.uri)
                    blob = await response.blob()
                } else {
                    // For React Native, use a different approach
                    // Convert base64 to binary string
                    const binaryString = atob(base64Data)

                    // Create Uint8Array from binary string
                    const bytes = new Uint8Array(binaryString.length)
                    for (let i = 0; i < binaryString.length; i++) {
                        bytes[i] = binaryString.charCodeAt(i)
                    }

                    blob = new Blob([bytes], { type: selectedFile.type })
                }
            } else if (selectedFile.uri.startsWith('file:') || selectedFile.uri.startsWith('content:')) {
                // Handle file URI (mobile)
                const response = await fetch(selectedFile.uri)
                blob = await response.blob()
            } else {
                // Handle File object (web)
                blob = selectedFile.file || new Blob([selectedFile.uri], { type: selectedFile.type })
            }

            return await uploadData({
                key: fileName,
                data: blob,
                options: {
                    contentType: selectedFile.type,
                    accessLevel: 'guest',
                    onProgress: ({ transferredBytes, totalBytes }) => {
                        if (totalBytes) {
                            const percentage = Math.round((transferredBytes / totalBytes) * 100)
                            progressCallback && progressCallback(percentage)
                        }
                    },
                },
            }).result.catch(err => {
                console.log('Error uploading file:', err)
                throw err
            })
        } catch (error) {
            console.error('Error processing file for upload:', error)
            throw error
        }
    }

    const getFileByName = async (fileName: string) => {
        return await getUrl({ key: fileName })
    }

    return {
        putStorageFile,
        getFileByName,
    }
}
